import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {IonDatetime, ModalController} from '@ionic/angular';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-fecha',
  templateUrl: './fecha.component.html',
  styleUrls: ['./fecha.component.scss'],
})
export class FechaComponent implements OnInit {

  @ViewChild('date') date: IonDatetime;

  @Input() tipofecha: string;
  @Input() fecha: string;
  @Input() min: string;
  @Input() max: string;
  @Input() tipo: 'date' | 'time' = 'date';
  @Input() borrar: boolean = true;
  @Input() rueda: boolean = false;
  @Input() now: boolean = false;

  titulos = {
    fechaLimite: ' límite',
    fnac: ' de nacimiento',
    falta: ' de alta',
    fbaja: ' de baja',
    inicio: ' desde',
    final: ' hasta',
    entrada: ' de entrada',
    salida: ' de salida'
  };
  titulo = 'Selecciona la fecha';

  constructor(
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    if (this.tipo === 'time') {
      this.titulo = 'Selecciona la hora';
      this.fecha = this.redondear(this.fecha)
    }
    if (this.tipofecha) {
      this.titulo += this.titulos[this.tipofecha] || ''
    }
  }

  private redondear = (date: string): string => {
    const dateTime = DateTime.fromISO(date),
      exceso: number = dateTime.minute % 5;
    if (exceso > 2) {
      return dateTime.plus({minutes: 5 - exceso}).toISO()
    }
    return dateTime.minus({minutes: exceso}).toISO()
  }

  cancel = () => this.modalCtrl.dismiss(null, 'cancel');

  go = async () => {
    await this.date.confirm()
    await this.modalCtrl.dismiss({detail: {value: this.date.value}})
  }

  reset = () => this.modalCtrl.dismiss(null, 'clear');

  nowfn = () => this.modalCtrl.dismiss({detail: {value: DateTime.now().toISO()}});

}
